export default __webpack_public_path__ + "ed1fc8a58ffa80476cf15e4c0ee0353a.svg";